import FrameworkCourseController from "../../../framework-course.controller";

class Diagram5Controller extends FrameworkCourseController {

  constructor(courseService, diagramService, $translate, $timeout, $scope) {
    'ngInject';
    super(courseService, diagramService, $translate, $timeout, $scope);
    this.isFiveSection = true
    this.amountCorrectAnswers = 5;
    this.exerciseId = 'exercise-3'
    this.clearDiagramId = 3
    this.pyramidData = {
      exerciseNumber: 3,
      scheme: {
        model: {
          textarea: 'Essentially we want to understand what it would take for Slade to operate profitably in the Chinese Health Care market',
        },
        children: [
          {
            model: {
              textarea: 'Deal specifically with the issues concerning us',
            },
            children: [

            ]
          },
          {
            model: {
              textarea: 'Enlighten us on other factors that drive high S&M costs',
            },
            children: [

            ]
          },
          {
            model: {
              textarea: 'Draw conclusions on future development of the market',
            },
            children: [

            ]
          },
        ],
      },
      scq: {
        's-header': 'DE, Sit',
        'c-header': 'R1, R2, Sol',
      },
      instruction: 'This looks complex, but it is easy to deal with once you get the Situation for the problem definition laid out. The Disturbing Event is obvious once you go back to the background information I gave you at the beginning.'
    };
  }

}

export default Diagram5Controller;



// WEBPACK FOOTER //
// ./client/app/components/diagrams/5/5d/diagram5/diagram5.controller.js